// Viewer
import { VcViewer } from 'casc-cesium-components/viewer'
// controls
import {
  VcCompass,
  VcZoomControl,
  VcPrint,
  VcMyLocation,
  VcStatusBar,
  VcDistanceLegend,
  VcNavigation,
  VcCompassSm,
  VcZoomControlSm,
  VcNavigationSm,
  VcOverviewMap,
  VcSelectionIndicator
} from 'casc-cesium-components/controls'
// tools
import VcMeasurements from 'casc-cesium-components/measurements'
import VcDrawings from 'casc-cesium-components/drawings'
// ImagerLayer
import VcLayerImagery from 'casc-cesium-components/imagery-layer'
import {
  VcImageryProviderAmap,
  VcImageryProviderArcgis,
  VcImageryProviderBaidu,
  VcImageryProviderBing,
  VcImageryProviderGoogle,
  VcImageryProviderGrid,
  VcImageryProviderIon,
  VcImageryProviderMapbox,
  VcImageryProviderOsm,
  VcImageryProviderSingletile,
  VcImageryProviderSupermap,
  VcImageryProviderTencent,
  VcImageryProviderTianditu,
  VcImageryProviderTileCoordinates,
  VcImageryProviderTms,
  VcImageryProviderTiledcache,
  VcImageryProviderUrltemplate,
  VcImageryProviderWms,
  VcImageryProviderWmts,
  VcTerrainProviderCesium,
  VcTerrainProviderArcgis,
  VcTerrainProviderVrTheworld,
  VcTerrainProviderTianditu
} from 'casc-cesium-components/providers'

// Datasource
import { VcDatasourceCustom, VcDatasourceCzml, VcDatasourceGeojson, VcDatasourceKml } from 'casc-cesium-components/datasources'

// Entity
import VcEntity from 'casc-cesium-components/entity'

// Grapics
import {
  VcGraphicsBillboard,
  VcGraphicsBox,
  VcGraphicsCorridor,
  VcGraphicsCylinder,
  VcGraphicsEllipse,
  VcGraphicsEllipsoid,
  VcGraphicsLabel,
  VcGraphicsModel,
  VcGraphicsPath,
  VcGraphicsPlane,
  VcGraphicsPoint,
  VcGraphicsPolygon,
  VcGraphicsPolyline,
  VcGraphicsPolylineVolume,
  VcGraphicsRectangle,
  VcGraphicsTileset,
  VcGraphicsWall
} from 'casc-cesium-components/graphics'

// Primitives
import {
  VcPrimitiveClassification,
  VcPrimitiveGround,
  VcPrimitiveGroundPolyline,
  VcPrimitiveModel,
  VcPrimitive,
  VcPrimitiveTileset,
  VcPrimitiveParticle
} from 'casc-cesium-components/primitives'

// PrimitiveCollections
import {
  VcCollectionBillboard,
  VcCollectionCloud,
  VcCollectionLabel,
  VcCollectionPoint,
  VcCollectionPolyline,
  VcCollectionPrimitive,
  VcBillboard,
  VcCumulusCloud,
  VcLabel,
  VcPoint,
  VcPolyline,
  VcPolygon
} from 'casc-cesium-components/primitive-collections'

// GeometryInstance
import VcGeometryInstance from 'casc-cesium-components/geometry-instance'

// Geometries
import {
  VcGeometryBox,
  VcGeometryBoxOutline,
  VcGeometryCircle,
  VcGeometryCircleOutline,
  VcGeometryPolygonCoplanar,
  VcGeometryPolygonCoplanarOutline,
  VcGeometryCorridor,
  VcGeometryCorridorOutline,
  VcGeometryCylinder,
  VcGeometryCylinderOutline,
  VcGeometryEllipse,
  VcGeometryEllipseOutline,
  VcGeometryEllipsoid,
  VcGeometryEllipsoidOutline,
  VcGeometryFrustum,
  VcGeometryFrustumOutline,
  VcGeometryGroundPolyline,
  VcGeometryPlane,
  VcGeometryPlaneOutline,
  VcGeometryPolygon,
  VcGeometryPolygonOutline,
  VcGeometryPolyline,
  VcGeometryPolylineVolume,
  VcGeometryPolylineVolumeOutline,
  VcGeometryRectangle,
  VcGeometryRectangleOutline,
  VcGeometrySimplePolyline,
  VcGeometrySphere,
  VcGeometrySphereOutline,
  VcGeometryWall,
  VcGeometryWallOutline
} from 'casc-cesium-components/geometries'

// Overlay
import { VcOverlayHtml, VcOverlayHeatmap, VcOverlayWind, VcOverlayDynamic } from 'casc-cesium-components/overlays'

import { VcPostProcessStage, VcPostProcessStageScan, VcPostProcessStageCollection } from 'casc-cesium-components/post-processes'

// UI
import {
  VcBtn,
  VcIcon,
  VcTooltip,
  VcAjaxBar,
  VcSkeleton,
  VcSpinnerBall,
  VcSpinnerBars,
  VcSpinnerDots,
  VcSpinnerGears,
  VcSpinnerHourglass,
  VcSpinnerIos,
  VcSpinnerOrbit,
  VcSpinnerOval,
  VcSpinnerPuff,
  VcSpinnerRings,
  VcSpinnerTail,
  VcSpinner,
  VcFab,
  VcFabAction
} from 'casc-cesium-components/ui'

// config
import VcConfigProvider from 'casc-cesium-components/config-provider'

// analyses
import { VcAnalysisFlood, VcAnalyses } from 'casc-cesium-components/analyses'

import type { Plugin } from 'vue'

export default [
  VcViewer,

  VcCompass,
  VcZoomControl,
  VcPrint,
  VcMyLocation,
  VcStatusBar,
  VcDistanceLegend,
  VcNavigation,
  VcCompassSm,
  VcZoomControlSm,
  VcNavigationSm,
  VcOverviewMap,
  VcSelectionIndicator,

  VcMeasurements,
  VcDrawings,

  VcLayerImagery,
  VcImageryProviderAmap,
  VcImageryProviderArcgis,
  VcImageryProviderBaidu,
  VcImageryProviderBing,
  VcImageryProviderGoogle,
  VcImageryProviderGrid,
  VcImageryProviderIon,
  VcImageryProviderMapbox,
  VcImageryProviderOsm,
  VcImageryProviderSingletile,
  VcImageryProviderSupermap,
  VcImageryProviderTencent,
  VcImageryProviderTianditu,
  VcImageryProviderTileCoordinates,
  VcImageryProviderTms,
  VcImageryProviderTiledcache,
  VcImageryProviderUrltemplate,
  VcImageryProviderWms,
  VcImageryProviderWmts,

  VcTerrainProviderCesium,
  VcTerrainProviderArcgis,
  VcTerrainProviderVrTheworld,
  VcTerrainProviderTianditu,

  VcDatasourceCustom,
  VcDatasourceCzml,
  VcDatasourceGeojson,
  VcDatasourceKml,

  VcEntity,
  VcGraphicsBillboard,
  VcGraphicsBox,
  VcGraphicsCorridor,
  VcGraphicsCylinder,
  VcGraphicsEllipse,
  VcGraphicsEllipsoid,
  VcGraphicsLabel,
  VcGraphicsModel,
  VcGraphicsPath,
  VcGraphicsPlane,
  VcGraphicsPoint,
  VcGraphicsPolygon,
  VcGraphicsPolyline,
  VcGraphicsPolylineVolume,
  VcGraphicsRectangle,
  VcGraphicsTileset,
  VcGraphicsWall,

  VcPrimitiveClassification,
  VcPrimitiveGround,
  VcPrimitiveGroundPolyline,
  VcPrimitiveModel,
  VcPrimitive,
  VcPrimitiveTileset,
  VcPrimitiveParticle,

  VcCollectionBillboard,
  VcCollectionCloud,
  VcCollectionLabel,
  VcCollectionPoint,
  VcCollectionPolyline,
  VcCollectionPrimitive,

  VcBillboard,
  VcCumulusCloud,
  VcLabel,
  VcPoint,
  VcPolyline,
  VcPolygon,

  VcGeometryInstance,

  VcGeometryBox,
  VcGeometryBoxOutline,
  VcGeometryCircle,
  VcGeometryCircleOutline,
  VcGeometryPolygonCoplanar,
  VcGeometryPolygonCoplanarOutline,
  VcGeometryCorridor,
  VcGeometryCorridorOutline,
  VcGeometryCylinder,
  VcGeometryCylinderOutline,
  VcGeometryEllipse,
  VcGeometryEllipseOutline,
  VcGeometryEllipsoid,
  VcGeometryEllipsoidOutline,
  VcGeometryFrustum,
  VcGeometryFrustumOutline,
  VcGeometryGroundPolyline,
  VcGeometryPlane,
  VcGeometryPlaneOutline,
  VcGeometryPolygon,
  VcGeometryPolygonOutline,
  VcGeometryPolyline,
  VcGeometryPolylineVolume,
  VcGeometryPolylineVolumeOutline,
  VcGeometryRectangle,
  VcGeometryRectangleOutline,
  VcGeometrySimplePolyline,
  VcGeometrySphere,
  VcGeometrySphereOutline,
  VcGeometryWall,
  VcGeometryWallOutline,

  VcOverlayHtml,
  VcOverlayHeatmap,
  VcOverlayWind,
  VcOverlayDynamic,

  VcPostProcessStage,
  VcPostProcessStageScan,
  VcPostProcessStageCollection,

  VcBtn,
  VcIcon,
  VcTooltip,
  VcAjaxBar,
  VcSkeleton,
  VcSpinnerBall,
  VcSpinnerBars,
  VcSpinnerDots,
  VcSpinnerGears,
  VcSpinnerHourglass,
  VcSpinnerIos,
  VcSpinnerOrbit,
  VcSpinnerOval,
  VcSpinnerPuff,
  VcSpinnerRings,
  VcSpinnerTail,
  VcSpinner,
  VcFab,
  VcFabAction,

  VcConfigProvider,
  VcAnalysisFlood,
  VcAnalyses
] as Plugin[]
